import firebaseApi from "./firebaseApi";

export async function sendRecipeToEmail(email, recipe) {
    try{
        const url = `/sendRecipeToEmail?email=${email}&recipeId=${recipe.id}&recipeType=${recipe.recipeType}&servings=${recipe.savedServings}`;
        await firebaseApi.get(url);
    }catch(e) {
        console.log("error while sending recipe to email", e)
    }
}